<template>
  <!--                   表头日期组件                           -->
  <!--  :style="{'margin-left':-cellWidth/2+'px'}" :style="{width:getTimeScales(day).length*cellWidth+'px'}" -->

  <div class="gantt-timeline">
    <div class="gantt-timeline-weekBlock"
         v-for="(day, index) in getDays"
         :style="{width: cellWidth * 7 +'px',
         height: titleHeight + 'px',
         'line-height': titleHeight + 'px'}"
         :key="index">
      <el-tooltip placement="top"
                  effect="dark">
        <div slot="content">{{day[0].format("YY-MM-DD")}}至{{day[6].format("YY-MM-DD")}}</div>
        <div class="gantt-timeline-day">
          {{day[6].format("YY-MM-DD")}}</div>
      </el-tooltip>
      <!-- <div class="gantt-timeline-week "
           v-for="(item, detailIdx) in day"
           :key="detailIdx"
           :style="heightStyle">
        {{item.format("YY-MM-DD")}}</div> -->
      <!-- <div class="gantt-timeline-scale "
           :style="heightStyle">
        <div :style="cellWidthStyle">
          <div>{{getWeekStr(day)}}</div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import dayjs from "dayjs";
import { getBeginTimeOfTimeLine } from "../../../../../utils/timeLineUtils.js";
import { getDate, GetSunday, GetMonday } from '@/utils/timeLineUtils.js'

const START_DAY = Symbol();
const MIDDLE_DAY = Symbol();
const END_DAY = Symbol();

function isSameDay (one, two) {
  return one.isSame(two, "day");
}

export default {
  name: "Timeline",

  props: {
    start: {
      type: dayjs
    },
    end: {
      type: dayjs
    },
    cellWidth: {
      type: Number
    },
    titleHeight: {
      type: Number
    },
    scale: {
      type: Number
    }
  },

  computed: {
    /**
     * 天列表
     * @returns {[dayjs]} 该data中所有需要渲染的数据
     */
    getDays () {
      let temp = [];
      let temps = []
      let { start, end } = this;
      start = dayjs(GetMonday(new Date(start)))
      end = dayjs(GetSunday(new Date(end)))

      for (; !isSameDay(start, end); start = start.add(1, "day")) {
        temp.push(start);
      }
      temp.push(start);
      temps = this.SplitArray(7, temp)
      // console.log('111', temps[0][0])
      // for (let i = 0; i < temps.length; i++) {
      //   debugger
      //   console.log('1231234', temps[i].index[0])
      // }
      console.log('====temps=====>>> ', temps)
      console.info('temps-------------------------->', temps)
      return temps;
    },
    cellWidthStyle () {
      return {
        width: `${this.cellWidth}px`
      };
    },
    heightStyle () {
      return {
        display: 'inline-block',
        width: this.cellWidth + "px",
        height: this.titleHeight / 2 + "px",
        "line-height": this.titleHeight / 2 + "px"
      };
    }
  },

  methods: {
    SplitArray (N, Q) {
      var R = [], F;
      for (F = 0; F < Q.length;) R.push(Q.slice(F, F += N))
      return R
    },
    /**
     * 星期
     * @returns
     */
    getWeek (weekNum) {
      let str = '星期';
      switch (weekNum) {
        case 0:
          str += "日";
          break;
        case 1:
          str += "一";
          break;
        case 2:
          str += "二";
          break;
        case 3:
          str += "三";
          break;
        case 4:
          str += "四";
          break;
        case 5:
          str += "五";
          break;
        case 6:
          str += "六";
          break;
        default:
          throw new TypeError("获取星期错误");
      }
      return str;
    },

    getWeekStr (date) {
      return this.getWeek(date.day())
    },

    /**
     * 获取时间刻度数组
     *
     * @param {dayjs} date
     * @returns {[string]} 该data中所有需要渲染的数据
     */
    getTimeScales (date) {
      let { start, end } = this;

      if (isSameDay(date, start)) {
        // eslint-disable-next-line
        return this.generateTimeScale(START_DAY);
      } else if (isSameDay(date, end)) {
        // eslint-disable-next-line
        return this.generateTimeScale(END_DAY);
      } else {
        // eslint-disable-next-line
        return this.generateTimeScale(MIDDLE_DAY);
      }
    },
    /**
     * 生成时间刻度数组
     *
     * @param {Symbol} type
     * @returns {[string]} 该data中所有需要渲染的数据
     */
    generateTimeScale (type) {
      let totalblock = [];
      let { start, end, scale } = this;
      let a, b;
      switch (type) {
        case START_DAY: //和start同一天
          a = getBeginTimeOfTimeLine(start, scale);
          //start和end同一天特殊处理
          if (isSameDay(start, end)) {
            b = end;
          } else {
            b = start.endOf("day");
          }
          break;
        case END_DAY: //和end 同一天
          a = end.startOf("day");
          b = end;
          break;
        case MIDDLE_DAY: //start和end中间的天
          a = start.startOf("day");
          b = start.endOf("day");
          break;
        default:
          throw new TypeError("错误的计算类型");
      }
      while (!a.isAfter(b)) {
        if (scale >= 60) {
          totalblock.push(a.format("HH"));
        } else {
          totalblock.push(a.format("HH:mm"));
        }
        a = a.add(scale, "minute");
      }

      return totalblock;
    }
  }
};
</script>